"use client";

const Footer = () => {
  return (
    <footer className="flex flex-col items-center text-base-content bg-base-300 p-4 md:flex-row md:justify-between">
      <div className="mt-4 md:mt-0 flex items-center order-2 md:order-1">
        <span className="mr-1">🦉</span>
        <a
          className="link"
          href="https://www.de.ed.ac.uk/project/ai-teaching-innovation"
          target="_blank"
          rel="noopener noreferrer"
        >
          AI for Teaching Innovation
        </a>

        <span className="mr-2 ml-2">|</span>
        <a
          className="link"
          href="https://forms.cloud.microsoft/e/MuFxPUUcMM"
          target="_blank"
          rel="noopener noreferrer"
        >
          Survey
        </a>
      </div>
      <div className="flex flex-col items-center gap-2 md:flex-row md:gap-4 order-1 md:order-2">
        <a className="link" href="/your-data" target="_blank">
          Your Data
        </a>
        <a
          className="link"
          href="https://aiforteachinginnovation.efi.ed.ac.uk/accessibility"
          target="_blank"
          rel="noopener noreferrer"
        >
          Accessibility
        </a>
        <a
          className="link"
          href="https://forms.office.com/e/Fc4K4XUFbj"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact
        </a>
      </div>
    </footer>
  );
};

export default Footer;
